/*
Author: Eli Elad Elrom
Website: https://EliElrom.com
License: MIT License
Component: src/components/OfferingContent.tsx
*/

import React, { useState } from 'react';
import {
  ContentWrapper,
  Description,
  OfferingCopyContent,
  HomePageTitle,
  WidgetWrapper,
  PlayPause,
  ButtonWrapper,
} from './HomePage.css';
import WordsBubblesWidget from '../../widgets/WordsBubblesWidget/WordsBubblesWidget';
import { Pause, Play } from '../../shared/Svg';

const ReactRotatingText = require('react-rotating-text');

export default function OfferingContent({ isLightsOn, initialPause }: IAnimatedHeaderContentProps) {
  const [pause, setPause] = useState(initialPause);
  const [updateContent, setUpdateContent] = useState(false);

  const titles = ['Full Stack Developer', 'Plan, Code & Publish'];

  const handlePause = () => {
    if (!pause) {
      setPause(true);
    } else {
      setPause(false);
    }
  };

  return (
    <>
      <ContentWrapper>
        <OfferingCopyContent>
          <HomePageTitle paddingTop="60%">
            {pause ? (
              <>{titles[0]}</>
            ) : (
              <ReactRotatingText
                onTypingEnd={() => setUpdateContent(true)}
                onTypingStart={() => setUpdateContent(false)}
                items={titles}
              />
            )}
          </HomePageTitle>
          <Description top="0em">
            I can help you plan, code, innovate, integrate, and launch websites, web apps, mobile
            apps, and systems. My philosophy is to partner with my clients closely to best reach
            long term goals.
          </Description>
        </OfferingCopyContent>
        <ButtonWrapper onClick={handlePause}>
          <PlayPause onClick={handlePause}>{pause ? <Play /> : <Pause />}</PlayPause>
        </ButtonWrapper>
      </ContentWrapper>
      <WidgetWrapper id="widget-wrapper">
        <WordsBubblesWidget updateContent={updateContent} isLightsOn={isLightsOn} />
      </WidgetWrapper>
    </>
  );
}

interface IAnimatedHeaderContentProps {
  isLightsOn: boolean;
  initialPause: boolean;
}
